import EngineModule                from '../../../EngineModule';
import { NS as StandingStorageNS } from '../../../components/customers/standing/StandingStorage/StandingStorage';

export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	id :               'standing-storage',
	dependencies :     [
		'oms-basket',
		'viewer-planner',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor'
	],
	modulesBefore :    [
		'product-editor',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor',
		'viewer-planner-floor-editor',
		'viewer-planner-walls-editor',
		'standing-highSign'
	],
	modulesAfter :     [
		'standing-counter',
		'standing-partitionsHeads',
		'viewer-planner-furniture-editor'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	usableCondition :  {
		type : 'and',
		LHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  'TARGET.basket.currentProduct',
			value :     null
		},
		RHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
			value :     null
		}
	},
	displayCondition : {
		type : 'and',
		LHS : {
			type : 'or',
			LHS : {
				type : 'and',
				LHS :  {
					type :      'notequal',
					component : 'K.basket',
					property :  'TARGET.basket.currentProduct',
					value :     null
				},
				RHS :  {
					type : 'or',
					LHS : {
						type :      'equal',
						component : 'K.basket',
						property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
						value :     null
					},
					RHS : {
						type : 'and',
						LHS : {
							type :      'notequal',
							component : 'K.basket',
							property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
							value :     null
						},
						RHS : {
							type :      'notequal',
							component : 'K.basket',
							property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption.id',
							value :     'shape-no-wall'
						}
					}
				}
			},
			RHS : {
				type :      'equal',
				component : 'K.basket',
				property :  'TARGET.basket.currentProduct',
				value :     null
			}
		},
		RHS : {
			type : 'or',
			LHS : {
				type : 'or',
				LHS : {
					type : 'and',
					LHS : {
						type :      'superiorequal',
						component : 'K',
						property :  'TARGET.standSurface',
						value :     18
					},
					RHS : {
						type :      'equal',
						component : 'K',
						property :  'TARGET.currentProduct.reference.value',
						value :     'confort'
					}
				},
				RHS : {
					type : 'and',
					LHS :  {
						type : 'and',
						LHS :  {
							type : 'or',
							LHS :  {
								type : 'and',
								LHS :  {
									type :      'notequal',
									component : 'K.basket',
									property :  'TARGET.basket.currentProduct',
									value :     null
								},
								RHS :  {
									type :      'notequal',
									component : 'K.basket',
									property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption.id',
									value :     'shape-left-back-right'
								}
							},
							RHS :  {
								type :      'superiorequal',
								component : 'K',
								property :  'TARGET.width',
								value :     3.75
							}
						},
						RHS :  {
							type :      'superiorequal',
							component : 'K',
							property :  'TARGET.standSurface',
							value :     12
						}
					},
					RHS :  {
						type :      'equal',
						component : 'K',
						property :  'TARGET.currentProduct.reference.value',
						value :     'siae'
					}
				}
			},
			RHS : {
				type : 'or',
				LHS : {
					type : 'and',
					LHS : {
						type :      'equal',
						component : 'K',
						property :  'TARGET.currentProduct.reference.value',
						value :     'business'
					},
					RHS : {
						type : 'and',
						LHS : {
							type : 'and',
							LHS : {
								type :      'or',
								LHS : {
									type : 'and',
										LHS :  {
											type :      'notequal',
											component : 'K.basket',
											property :  'TARGET.basket.currentProduct',
											value :     null
										},
										RHS :  {
											type : 'and',
											LHS : {
												type :      'notequal',
												component : 'K.basket',
												property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption.id',
												value :     'shape-back-right'
											},
											RHS : {
												type :      'notequal',
												component : 'K.basket',
												property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption.id',
												value :     'shape-back-left'
											}
										}
								},	
								RHS : {
									type :      'superiorequal',
									component : 'K',
									property :  'TARGET.depth',
									value :     4
								}
							},
							RHS : {
								type :      'or',
								LHS : {
									type : 'and',
										LHS :  {
											type :      'notequal',
											component : 'K.basket',
											property :  'TARGET.basket.currentProduct',
											value :     null
										},
										RHS :  {
											type :      'notequal',
											component : 'K.basket',
											property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption.id',
											value :     'shape-left-back-right'
										}
								},	
								RHS : {
									type :      'superiorequal',
									component : 'K',
									property :  'TARGET.width',
									value :     4
								}
							}
						},
						RHS : {
							type :      'superiorequal',
							component : 'K',
							property :  'TARGET.standSurface',
							value :     12
						}
					}
				},
				RHS : {
					type : 'and',
					LHS : {
						type :      'equal',
						component : 'K',
						property :  'TARGET.currentProduct.reference.value',
						value :     'prestige'
					},
					RHS : {
						type : 'and',
						LHS : {
							type :      'or',
							LHS : {
								type : 'and',
									LHS :  {
										type :      'notequal',
										component : 'K.basket',
										property :  'TARGET.basket.currentProduct',
										value :     null
									},
									RHS :  {
										type :      'notequal',
										component : 'K.basket',
										property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption.id',
										value :     'shape-left-back-right'
									}
							},	
							RHS : {
								type :      'superiorequal',
								component : 'K',
								property :  'TARGET.width',
								value :     4
							}
						},
						RHS :  {
							type :      'superiorequal',
							component : 'K',
							property :  'TARGET.standSurface',
							value :     18
						}
					}
				}
			}
		}
	},
	generateComponentConfiguration() : StandingStorageNS.Configuration {
		return {
			translations : this.translations
		};
	},
	async initialize() {
	}
});
